export default {"src":"/_next/static/media/GitLab.19d62a90.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};